import { isNotDefined } from '@sgme/fp';
import { Select } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useIntl } from 'react-intl';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useCheckOption } from '@/App/tiles/Option/QueueContext.tsx';
import type { LegId } from '@/store/option/state.ts';

type TriggerTypeProps = {
  tileId: string;
  legId: LegId;
};

export function TriggerType({ tileId, legId }: TriggerTypeProps) {
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const { formatMessage } = useIntl();
  const [checkOption] = useCheckOption();
  const { barrier1, barrier2 } = useOptionSelector((option) => {
    const leg = option.properties.legs.find((l) => l.legId === legId);
    return {
      barrier1: leg?.barrier1,
      barrier2: leg?.barrier2,
    };
  });

  function handleTriggerTypeChange(triggerType: 1 | 2) {
    sgwtWebAnalytics?.trackEvent('Option', 'trigger type changed', String(triggerType));

    checkOption({
      tileId,
      legProperties: {
        legId,
        ...(triggerType === 1 ? { barrier1: {}, barrier2: null } : { barrier2: {} }),
      },
    });
  }

  if (isNotDefined(barrier1) && isNotDefined(barrier2)) {
    return null;
  }
  const selectedItemValue = isNotDefined(barrier2) ? 1 : 2;

  return (
    <div className="d-flex flex-grow-1 gap-1">
      <Select
        data-e2e="trigger-type-select"
        className="form-select bg-primary-alt form-select-sm"
        selectedItemValue={String(selectedItemValue)}
        itemToString={(item) => formatMessage({ id: `option.fields.triggerType.${item}` })}
        itemsAsObjects={[1, 2]}
        onChange={handleTriggerTypeChange}
      />
    </div>
  );
}
